import React, { Component } from 'react';


export class CalendarsSelect extends Component {

    updateState = (e) => {
        this.props.updateCalendarId(e.target.value);
    };

    render() {
        return (
            <select
                className="calendars-select"
                onChange={this.updateState}
                value={this.props.selectedCalendarId}
            >
                <option key="0" value="">Select calendar</option>
                {
                    this.props.calendarList.map((el) => (
                        <option key={el.id} value={el.id}>{ el.name }</option>
                    ))
                }
            </select>
        );
    }
}
